import React, { useEffect, useState, useRef } from 'react';
import { injectIntl } from 'react-intl';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import HomeItem from '../HomeItem';
import CitySectionSwiperSkeleton from '../../Skeleton/Home/CitySectionSkeleton/CitySectionSwiperSkeleton/CitySectionSwiperSkeleton';

import { isRTL } from '../../../helpers/formatLocale';
import { encode } from '../../../helpers/queryEncryption';
import { SwiperNextIcon, SwiperPrevIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';
import { openHeaderModal } from '../../../actions/siteadmin/modalActions';
import { setRuntimeVariable } from '../../../actions/runtime';
import history from '../../../history';
import cs from 'swiper/swiper-bundle.css';
import s from '../../../styles/customSwiper.css';
import t from './HomeSlider.css';



const ArrowButton = ({ className, children }) => (
  <button className={className}>
    {children}
  </button>
);


const HomeSlider = ({ data = [], intl: { locale } }) => {
  const [load, setLoad] = useState(false);
  const rtl = isRTL(locale);

  useEffect(() => {
    setLoad(true);
    return () => clearTimeout(loadSync.current);
  }, []);

  const loadSync = useRef(null);
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(state => state?.runtime?.isAuthenticated)

  useEffect(() => {
    setLoad(false);
    if (loadSync.current) clearTimeout(loadSync.current);
    loadSync.current = setTimeout(() => {
      setLoad(true);
    }, 1);
  }, [locale]);

  const handleClickCategory = (redirectUrl) => {
    // Guests browse the whole funnel logged-out (guest-cart flow); login is deferred to
    // "Review Your Request". Navigate everyone into the category instead of walling guests.
    return history.push(redirectUrl);
  }

  const params = {
    slidesPerView: 1,
    spaceBetween: 10,
    modules: [Navigation],
    navigation: {
      nextEl: `.whatWeOfferSwiperNavigationNextBtn`,
      prevEl: `.whatWeOfferSwiperNavigationPrevBtn`,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      360: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
      1300: {
        slidesPerView: 7,
        spaceBetween: 30,
      }
    }
  };

  return (
    <>
      {!load && <CitySectionSwiperSkeleton />}

      {load && data?.results?.length > 0 && (
        <div className='swiperSliderRelativeContainer'>
          <Swiper
            {...params}
            key={rtl} // force remount on language change
            dir={rtl ? 'rtl' : 'ltr'}
          >
            {data?.results?.filter(item => item?.isPopular).map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <div onClick={() => handleClickCategory(`/category?type=${encodeURIComponent(encode(item?.id?.toString()))}`)} className={t.categoryBoxLink}>
                    <HomeItem
                      categoryName={item.name}
                      categoryLogo={item.logoImage}
                    />
                  </div>
                </SwiperSlide>)
            })}
          </Swiper>
          <ArrowButton children={<SwiperPrevIcon />} className={cx('whatWeOfferSwiperNavigationPrevBtn')} />
          <ArrowButton children={<SwiperNextIcon />} className={cx('whatWeOfferSwiperNavigationNextBtn')} />
        </div>
      )}
    </>
  );
};

export default injectIntl(withStyles(cs, s, t)(HomeSlider));